export function isSelectionIndexCacheValid(cache, deps) {
  if (!cache) return false
  return cache.manifest === deps.manifest
    && cache.visibleLayers === deps.visibleLayers
    && cache.soloLayers === deps.soloLayers
    && cache.activeView === deps.activeView
}
